<template>
    <section class="w-full flex flex-col gap-5 ">
    <div class="relative md:hover:bg-gray-100 shadow-lg md:p-0 p-2  rounded-lg">
        <span
    class="absolute top-4 left-2 whitespace-nowrap rounded-full font-bold border-cv px-2.5 py-0.5 text-sm text-cv"
  >
    Orienté social média
  </span>
        <div class="flex justify-center md:mt-2 mt-16  flex-col items-center">
            <h1>THE SPOT</h1>
            <hr class="md:w-1/3 w-1/2 mt-5 rounded-lg border-1 mb-5 border-cv">
        </div>
        <div class="flex md:flex-row flex-col md:p-2 rounded-lg gap-2">
            <!-- Section de texte -->
            <div class="md:w-4/6 mb-4 md:mb-0">
                
                <div>   
                    <h1 class="font-bold text-4xl items-start flex justify-start mb-4">Brief</h1>
                    <p>The spot surfcamp propose des surftrips pour les amateurs de surf.</p>
                    <br>
                    <ul>
                        <li>La demande :</li>
                        <ul>
                            <li><span class="ml-7 mr-3 text-2xl text-cv">•</span><span class="underline text-cv">Promouvoir</span> un voyage en Afrique du Sud</li>
                            <li><span class="ml-7 mr-3 text-2xl text-cv">•</span><span class="underline text-cv">Trouver</span> un concept créatif</li>
                            <li><span class="ml-7 mr-3 text-2xl text-cv">•</span><span class="underline text-cv">Mettre</span> en place une stratégie social media</li>
                        </ul>
                        <li>Notre concept : <span class="font-bold">"Tu gères ta vague, et nous le reste"</span></li>
                    </ul>
                    <div  class="flex flex-row flex-wrap items-center  mt-5">
                        <p><span class="font-bold">Logiciels mobilisés : </span></p>
                        <img class="h-10 ml-2 p-2  hover:bg-gray-300 rounded-lg" src="@/assets/IL.png" alt="">
                        <p>|</p>
                        <img class="h-10 p-2  hover:bg-gray-300 rounded-lg" src="@/assets/PS.png" alt="">
                        <p>|</p>
                        <img class="h-10 p-2  hover:bg-gray-300 rounded-lg" src="@/assets/instagram.png" alt="">
                        <p>|</p>
                        <img class="h-10 p-2  hover:bg-gray-300 rounded-lg" src="@/assets/tic-tac.png" alt="">
                        <p>|</p>
                        <img class="h-10 p-2  hover:bg-gray-300 rounded-lg" src="@/assets/facebook.png" alt="">
                    </div>
                </div>
            </div>

            <!-- Section d'images -->
            <div class="flex gap-2 ">
                <div class="flex flex-col gap-2 w-1/2">
                    <img :src="getImage('social1.jpg')" class="md:h-40 h-20 rounded-lg cursor-pointer object-cover" alt="" @click="openModal('social1.jpg')">
                    <img :src="getImage('social2.jpg')" class="md:h-40 h-20 rounded-lg cursor-pointer object-cover" alt="" @click="openModal('social2.jpg')">
                </div>
                <div class="flex flex-col gap-2 w-1/2">
                    <img :src="getImage('social3.jpg')" class="md:h-40 h-20 rounded-lg cursor-pointer object-cover" alt="" @click="openModal('social3.jpg')">
                    <img :src="getImage('social4.jpg')" class="md:h-40 h-20 rounded-lg cursor-pointer object-cover" alt="" @click="openModal('social4.jpg')">
                </div>
            </div>
            
        </div>
        <!-- Modal -->
<div v-if="isModalOpen" class="absolute top-0 left-0 w-full h-full flex items-center justify-center z-50 ">
  <div class="bg-white p-6 rounded-lg shadow-lg w-11/12 md:w-3/4 lg:w-1/2 relative">
    <button @click="closeModal" class="absolute top-4 right-4 bg-gray-200 rounded-full p-2 hover:bg-gray-300">
      ❌
    </button>
    <img :src="selectedImage" class="w-full h-auto rounded-lg">
  </div>
</div>


    </div>

    <div class="relative md:hover:bg-gray-100  rounded-lg shadow-lg  md:p-0 p-2 md:pb-0 pb-5">
            <span
    class="absolute top-4 left-2 whitespace-nowrap rounded-full font-bold border-cv px-2.5 py-0.5 text-sm text-cv"
  >
    Orienté social média
  </span>
        <div class="flex justify-center md:mt-2 mt-16 flex-col items-center">
          <h1>LAUREN COLASUONNO</h1>
          <hr class="md:w-1/3 w-1/2 mt-5 rounded-lg border-1 mb-5 border-cv">
        </div>

        <div class="flex md:flex-row flex-col md:p-2 rounded-lg gap-2 ">
          <!-- Section de texte -->
          <div class="md:w-4/6 mb-4 md:mb-0">
            <div>
              <h1 class="font-bold text-4xl items-start flex justify-start mb-4">Brief</h1>
              <p>Construire une présence en ligne cohérente
                <br>Recommandation créative 

              </p>
                <br>
              <ul>
                <li>Notre problématique :</li>
                <ul>
                <li class="flex">
                    <p class="font-bold"><span class="ml-7 mr-3 text-2xl text-cv">• </span>"</p>
                    <span class="font-bold flex-1">Comment céder une notoriété à la marque sachant que les consommateurs cherchent à se démarquer et s’exprimer grâce à l’achat de pièces distinctives ? "</span>
                </li>
                </ul>
              </ul>
              <ul>
                <li>Notre positionnement :</li>
                <ul>

                  <li class="flex">
                    <p class="font-bold"><span class="ml-7 mr-3 text-2xl text-cv">• </span>"</p>
                    <span class="font-bold flex-1"> La marque unisex de prêt à porter haut de gamme qui mélange le tailoring italien et l’urbain sophistiqué."</span></li>
                </ul>
              </ul>
              <div  class="flex flex-row flex-wrap items-center  mt-5">
                        <p><span class="font-bold">Logiciels mobilisés : </span></p>
                        <img class="h-10 ml-2 p-2  hover:bg-gray-300 rounded-lg" src="@/assets/IL.png" alt="">
                        <P>|</P>
                        <img class="h-10 p-2  hover:bg-gray-300 rounded-lg" src="@/assets/PS.png" alt="">
                        <P>|</P>
                        <img class="h-10 p-2  hover:bg-gray-300 rounded-lg" src="@/assets/instagram.png" alt="">
                        <P>|</P>
                        <img class="h-10 p-2  hover:bg-gray-300 rounded-lg" src="@/assets/tic-tac.png" alt="">
                        <P>|</P>
                        <img class="h-10 p-2  hover:bg-gray-300 rounded-lg" src="@/assets/facebook.png" alt="">
                        <P>|</P>
                        <img class="h-10 p-2  hover:bg-gray-300 rounded-lg" src="@/assets/meta.png" alt="">
                        <P>|</P>
                        <img class="h-10 p-2  hover:bg-gray-300 rounded-lg" src="@/assets/pinterest.png" alt="">

                    </div>
            </div>
          </div>
          

          <!-- Carrousel d'images pour ROMAN PHOTO -->
          <div class="relative flex flex-col items-center gap-2 mr-3">
            <div class="relative w-full max-w-md overflow-hidden">
              <button @click="prevSlide('Col')" class="absolute bg-black bg-opacity-50 backdrop-blur-xl left-0 top-1/2 transform -translate-y-1/2 text-white px-3 py-2 rounded-full"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
              </svg></button>              
              <img :src="imagesCol[currentIndexCol]" class="h-58 w-full object-cover rounded-lg" alt="Roman Photo">
              <button @click="nextSlide('Col')" class="absolute bg-black bg-opacity-50 backdrop-blur-xl right-0 top-1/2 transform -translate-y-1/2 text-white px-3 py-2 rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                </svg>
            </button>            
          </div>
            

            <div class="mt-2">
              <a href="/pdf/Projet-roman-photo.pdf" target="_blank" 
                class="py-2.5 px-6 text-sm rounded-full border border-solid border-cv text-cv cursor-pointer font-semibold text-center shadow-xs transition-all duration-500 hover:bg-cv hover:text-white">
                Voir le PDF
              </a>
            </div>
          </div>
        </div>
      </div>


      <div class="relative md:hover:bg-gray-100 rounded-lg shadow-lg  md:p-0 p-2  pb-4">
        <span
    class="absolute top-4 left-2 whitespace-nowrap rounded-full font-bold border-cv px-2.5 py-0.5 text-sm text-cv"
  >
    Orienté stratégie de communication
  </span>
        <div class="flex justify-center md:mt-2 mt-16 flex-col items-center">
          <h1>POKEDATE</h1>
          <hr class="md:w-1/3 w-1/2 mt-5 rounded-lg border-1 mb-5 border-cv">
        </div>

        <div class="flex md:flex-row flex-col md:p-2 rounded-lg gap-2">
          <!-- Section de texte -->
          <div class="md:w-4/6 mb-4 md:mb-0">
            <div>
              <h1 class="font-bold text-4xl items-start flex justify-start mb-4">Brief</h1>
              <p>Créer une application non existante
                <br>Mettre en place sa stratégie de communication en utilisant des moyens médias et hors média
                <br>Respecter le budget imposé


              </p>
                <br>
              
            </div>
            <div  class="flex flex-row flex-wrap items-center  mt-5">
                        <p><span class="font-bold">Logiciels mobilisés : </span></p>
                        
                        <img class="h-10 p-2  hover:bg-gray-300 rounded-lg" src="@/assets/instagram.png" alt="">
                        <P>|</P>
                        <img class="h-10 p-2  hover:bg-gray-300 rounded-lg" src="@/assets/tic-tac.png" alt="">
                        <P>|</P>
                        <img class="h-10 p-2  hover:bg-gray-300 rounded-lg" src="@/assets/facebook.png" alt="">
                        
                    </div>
          </div>
          

          <!-- Carrousel d'images pour ROMAN PHOTO -->
          <div class="relative flex flex-col items-center gap-2 mr-3">
            <div class="relative w-full max-w-md overflow-hidden">
              <button @click="prevSlide('Pokedate')" class="absolute bg-black bg-opacity-50 backdrop-blur-xl left-0 top-1/2 transform -translate-y-1/2 text-white px-3 py-2 rounded-full"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
              </svg></button>
              <img :src="imagesPokedate[currentIndexPokedate]" class="h-58 w-full object-cover rounded-lg" alt="Roman Photo">
              
              <button @click="nextSlide('Pokedate')" class="absolute bg-black bg-opacity-50 backdrop-blur-xl right-0 top-1/2 transform -translate-y-1/2 text-white px-3 py-2 rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                </svg>
              </button>        
            </div>
            

            <div class="my-2">
              <a href="/pdf/Pokedate.pdf" target="_blank" 
                class="py-2.5 px-6 text-sm rounded-full border border-solid border-cv text-cv cursor-pointer font-semibold text-center shadow-xs transition-all duration-500 hover:bg-cv hover:text-white">
                Voir le PDF
              </a>
            </div>
          </div>
        </div>
      </div>


    <div class="relative md:hover:bg-gray-100 rounded-lg pb-4 shadow-lg  md:p-0 p-2 ">
        <span
    class="absolute top-4 left-2 whitespace-nowrap rounded-full font-bold border-cv px-2.5 py-0.5 text-sm text-cv"
  >
    Orienté création
  </span>
        <div class="flex justify-center md:mt-2 mt-16 flex-col items-center">
          <h1>MAGAZINE DE BASKET</h1>
          <hr class="md:w-1/3 w-1/2 mt-5 rounded-lg border-1 mb-5 border-cv">
        </div>

        <div class="flex md:flex-row flex-col md:p-2 rounded-lg gap-2">
          <!-- Section de texte -->
          <div class="md:w-4/6 mb-4 md:mb-0">
            <div>
              <h1 class="font-bold text-4xl items-start flex justify-start mb-4">Brief</h1>
              <p>Créer une couverture et 2 pages de magazine sur un sport choisi.
                <br> Intégration d'un faux texte 
              </p>
              <div  class="flex flex-row items-center  mt-5">
                        <p><span class="font-bold">Logiciels mobilisés : </span></p>
                        <img class="h-10 ml-2 p-2  hover:bg-gray-300 rounded-lg" src="@/assets/IN.png" alt="">
                        <P>|</P>
                        <img class="h-10 p-2  hover:bg-gray-300 rounded-lg" src="@/assets/PS.png" alt="">

                    </div>
            </div>
          </div>
          

          <!-- Carrousel d'images pour MAGAZINE BASKET -->
          <div class="relative flex flex-col items-center gap-2 mr-3">
            <div class="relative w-full max-w-md overflow-hidden">
              <button @click="prevSlide('basket')" class="absolute bg-black bg-opacity-50 backdrop-blur-xl left-0 top-1/2 transform -translate-y-1/2 text-white px-3 py-2 rounded-full"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
              </svg></button>             
               <img :src="imagesBasket[currentIndexBasket]" class="h-auto w-full object-cover rounded-lg" alt="Magazine Basket">
              <button @click="nextSlide('basket')" class="absolute bg-black bg-opacity-50 backdrop-blur-xl right-0 top-1/2 transform -translate-y-1/2 text-white px-3 py-2 rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                </svg>
            </button>            </div>

            <div class="my-2">
              <a href="/pdf/Emma-Nabyt-Ind.pdf" target="_blank" 
                class="py-2.5 px-6 text-sm rounded-full border border-solid border-cv text-cv cursor-pointer font-semibold text-center shadow-xs transition-all duration-500 hover:bg-cv hover:text-white">
                Voir le PDF
              </a>
            </div>
          </div>
        </div>
      </div>
      
        <div class="relative  md:hover:bg-gray-100 rounded-lg pb-4 shadow-lg  md:p-0 p-2 ">
            <span
    class="absolute top-4 left-2 whitespace-nowrap rounded-full font-bold border-cv px-2.5 py-0.5 text-sm text-cv"
  >
    Orienté création
  </span>
            <div class="flex justify-center md:mt-2 mt-16 flex-col items-center">
          <h1>ROMAN PHOTO</h1>
          <hr class="md:w-1/3 w-1/2 mt-5 rounded-lg border-1 mb-5 border-cv">
        </div>
        <div class="flex md:flex-row flex-col md:p-2 rounded-lg gap-2">
          <!-- Section de texte -->
           
          <div class="md:w-4/6 mb-4 md:mb-0">
            
            <div>
              <h1 class="font-bold text-4xl items-start flex justify-start mb-4">Brief</h1>
              <p>Réaliser un roman photo sous forme de gaufrier à 9 vignettes
                <br>Une thématique et des éléments imposés
              </p>
                <br>
              <ul>
                <li>Le thème :</li>
                <ul>
                  <li><span class="ml-7 mr-3 text-2xl text-cv">•</span><span class="underline text-cv">Le polar</span></li>
                </ul>
              </ul>
              <ul>
                <li>Les 3 éléments :</li>
                <ul>
                  <li><span class="ml-7 mr-3 text-2xl text-cv">•</span><span class="underline text-cv">femme fatale, vol, épicerie</span></li>
                </ul>
              </ul>
              <div  class="flex flex-row items-center  mt-5">
                        <p><span class="font-bold">Logiciels mobilisés : </span></p>
                        <img class="h-10 ml-2 p-2  hover:bg-gray-300 rounded-lg" src="@/assets/IN.png" alt="">
                        <P>|</P>
                        <img class="h-10 p-2  hover:bg-gray-300 rounded-lg" src="@/assets/LR.png" alt="">

                    </div>
            </div>
          </div>
          

          <!-- Carrousel d'images pour ROMAN PHOTO -->
          <div class="relative flex flex-col items-center gap-2 mr-3">
            <div class="relative w-full max-w-md overflow-hidden">
              <button @click="prevSlide('roman')" class="absolute bg-black bg-opacity-50 backdrop-blur-xl left-0 top-1/2 transform -translate-y-1/2 text-white px-3 py-2 rounded-full"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
              </svg></button>
                             <img :src="imagesRoman[currentIndexRoman]" class="h-auto w-full object-cover rounded-lg" alt="Roman Photo">
            <button @click="nextSlide('roman')" class="absolute bg-black bg-opacity-50 backdrop-blur-xl right-0 top-1/2 transform -translate-y-1/2 text-white px-3 py-2 rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                </svg>
            </button>
            </div>

            <div class="my-2">
              <a href="/pdf/Projet-roman-photo.pdf" target="_blank" 
                class="py-2.5 px-6 text-sm rounded-full border border-solid border-cv text-cv cursor-pointer font-semibold text-center shadow-xs transition-all duration-500 hover:bg-cv hover:text-white">
                Voir le PDF
              </a>
            </div>
          </div>
        </div>
        </div>



        <div class="relative md:hover:bg-gray-100 rounded-lg shadow-lg  md:p-0 p-2 ">
            <span
    class="absolute top-4 left-2 whitespace-nowrap rounded-full font-bold border-cv px-2.5 py-0.5 text-sm text-cv"
  >
    Orienté création
  </span>
        <div class="flex justify-center md:mt-2 mt-16 flex-col items-center">
          <h1>REPRODUCTION PUB FANTA</h1>
          <hr class="md:w-1/3 w-1/2 mt-5 rounded-lg border-1 mb-5 border-cv">
        </div>

        <div class="flex md:flex-row flex-col md:p-2 rounded-lg gap-2">
          <!-- Section de texte -->
          <div class="md:w-4/6 mb-4 md:mb-0">
            <div>
              <h1 class="font-bold text-4xl items-start flex justify-strat mb-4">Brief</h1>
              <p>Réaliser une affiche mettant en valeur la canette Fanta
                
              </p>
              <div  class="flex flex-row items-center  mt-5">
                        <p><span class="font-bold">Logiciels mobilisés : </span></p>
                        <img class="h-10 ml-2 p-2  hover:bg-gray-300 rounded-lg" src="@/assets/IL.png" alt="">
                        <P>|</P>
                        <img class="h-10 p-2  hover:bg-gray-300 rounded-lg" src="@/assets/PS.png" alt="">

                    </div>
            </div>
          </div>

          <!-- Carrousel d'images pour MAGAZINE BASKET -->
          <div class="relative flex flex-col items-center gap-2 mr-3">
            <div class="w-full h-auto max-w-md overflow-hidden">
              <img src="@/assets/photo-canette.png" class="h-full w-full object-cover rounded-lg" alt="Magazine Basket">
            </div>

            
          </div>
        </div>
        </div>


        

        <div class="relative md:hover:bg-gray-100 rounded-lg shadow-lg  md:p-0 p-2 md:pb-0 pb-5">
            <span
    class="absolute top-4 left-2 whitespace-nowrap rounded-full font-bold border-cv px-2.5 py-0.5 text-sm text-cv"
  >
    Orienté création
  </span>
        <div class="flex justify-center md:mt-2 mt-16 flex-col items-center">
          <h1>ATELIER EMILIE GEISSLER</h1>
          <hr class="md:w-1/3 w-1/2 mt-5 rounded-lg border-1 mb-5 border-cv">
        </div>

        <div class="flex md:flex-row flex-col md:p-2 rounded-lg gap-2">
          <!-- Section de texte -->
          <div class="md:w-4/6 mb-4 md:mb-0">
            <div>
              <h1 class="font-bold text-4xl items-start flex justify-start mb-4">Brief</h1>
              <p>Proposer une nouvelle identité visuelle
                <br>Restructurer la stratégie de communication de la marque
              </p>
              <br>
              <ul>
                
                <li>Mots clés :</li>
                <ul>
                  <li><span class="ml-7 mr-3 text-2xl text-cv">•</span><span class="underline text-cv">Délicatesse, expertise, savoir-faire, luxe</span></li>
                </ul>
              </ul>
              <ul>
                <li>Notre concept :</li>
                <ul>
                  <li><span class="ml-7 mr-3 text-2xl text-cv">•</span><span class="font-bold">" La délicatesse au service de l’Art "</span></li>
                </ul>
              </ul>
              <ul>
                <li>Notre positionnement :</li>
                <ul>
                  <li><span class="ml-7 mr-3 text-2xl text-cv">•</span><span class="font-bold">" L’atelier de restauration d’art, à la fois digitalisé et délicat "</span></li>
                </ul>
              </ul>
              <div  class="flex flex-row items-center  mt-5">
                        <p><span class="font-bold">Logiciels mobilisés : </span></p>
                        <img class="h-10 ml-2 p-2  hover:bg-gray-300 rounded-lg" src="@/assets/IL.png" alt="">
                        <P>|</P>
                        <img class="h-10 p-2  hover:bg-gray-300 rounded-lg" src="@/assets/PS.png" alt="">

                    </div>
            </div>
          </div>
          

          <!-- Carrousel d'images pour ROMAN PHOTO -->
          <div class="relative flex flex-col items-center gap-2 mr-3">
            <div class="relative w-full max-w-lg overflow-hidden">
              <button @click="prevSlide('restauratrice')" class="absolute bg-black bg-opacity-50 backdrop-blur-xl left-0 top-1/2 transform -translate-y-1/2 text-white px-3 py-2 rounded-full"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
              </svg></button>
                            <img :src="imagesRestauratrice[currentIndexRestauratrice]" class="h-58 w-full object-cover rounded-lg" alt="Roman Photo">
              <button @click="nextSlide('restauratrice')" class="absolute bg-black bg-opacity-50 backdrop-blur-xl right-0 top-1/2 transform -translate-y-1/2 text-white px-3 py-2 rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                </svg>
            </button>            </div>

            <div>
              <a href="/pdf/Emilie-G.pdf" target="_blank" 
                class="py-2.5 px-6 text-sm rounded-full border border-solid border-cv text-cv cursor-pointer font-semibold text-center shadow-xs transition-all duration-500 hover:bg-cv hover:text-white">
                Voir le PDF
              </a>
            </div>
          </div>
        </div>
      </div>


    


       
      
    </section>
</template>

<script>
export default {
    data() {
        return {
            isModalOpen: false,
            selectedImage: '',
            isMobile: window.innerWidth <= 700,
            isOther: window.innerWidth > 700,
            currentIndexCol:0,
            currentIndexBasket: 0, // Index du carrousel MAGAZINE BASKET
            currentIndexRoman: 0, // Index du carrousel ROMAN PHOTO
            currentIndexRestauratrice:0,
            currentIndexPokedate:0,



            imagesRestauratrice: [
        require('@/assets/Photo-restauratrice1.png'),
        require('@/assets/Photo-restauratrice2.png'),
        require('@/assets/Photo-restauratrice3.png'),
        require('@/assets/Photo-restauratrice4.png'),
        require('@/assets/Photo-restauratrice5.png'),
        require('@/assets/Photo-restauratrice6.png'),
        require('@/assets/Photo-restauratrice7.png'),
        require('@/assets/Photo-restauratrice8.png'),
        require('@/assets/Photo-restauratrice9.png'),
        require('@/assets/Photo-restauratrice10.png')
      ],
      imagesPokedate: [
        require('@/assets/Pokedate1.png'),
        require('@/assets/Pokedate2.png'),
        require('@/assets/Pokedate3.png'),
        require('@/assets/Pokedate4.png'),
        require('@/assets/Pokedate5.png'),
        require('@/assets/Pokedate6.png'),
        require('@/assets/Pokedate7.png'),
        require('@/assets/Pokedate8.png'),
        require('@/assets/Pokedate9.png'),
        require('@/assets/Pokedate10.png'),
        require('@/assets/Pokedate11.png'),
        require('@/assets/Pokedate12.png'),
        require('@/assets/Pokedate13.png'),
        require('@/assets/Pokedate14.png'),
        require('@/assets/Pokedate15.png'),
        require('@/assets/Pokedate16.png'),
        require('@/assets/Pokedate17.png'),
        require('@/assets/Pokedate18.png'),
        require('@/assets/Pokedate19.png'),
        require('@/assets/Pokedate20.png'),
        require('@/assets/Pokedate21.png'),
        require('@/assets/Pokedate22.png'),
        require('@/assets/Pokedate23.png'),
        require('@/assets/Pokedate24.png'),
        require('@/assets/Pokedate25.png'),
        require('@/assets/Pokedate26.png'),
        require('@/assets/Pokedate27.png'),
        require('@/assets/Pokedate28.png'),
        require('@/assets/Pokedate29.png'),
        require('@/assets/Pokedate30.png'),
        require('@/assets/Pokedate31.png'),
        require('@/assets/Pokedate32.png'),
        require('@/assets/Pokedate33.png'),
        require('@/assets/Pokedate34.png'),
        require('@/assets/Pokedate35.png'),
        require('@/assets/Pokedate36.png'),
        require('@/assets/Pokedate37.png'),

      ],

            imagesCol: [
                require('@/assets/col1.png'),
                require('@/assets/col2.png'),
                require('@/assets/col3.png'),
                require('@/assets/col4.png'),
                require('@/assets/col5.png'),
                require('@/assets/col6.png'),
                require('@/assets/col7.png'),
                require('@/assets/col8.png'),
                require('@/assets/col9.png'),
                require('@/assets/col10.png'),
                require('@/assets/col11.png'),
                require('@/assets/col12.png'),
                require('@/assets/col13.png'),
                require('@/assets/col14.png'),
                require('@/assets/col15.png'),
                require('@/assets/col16.png'),
                require('@/assets/col17.png'),
                require('@/assets/col18.png'),
                require('@/assets/col19.png'),
                require('@/assets/col20.png'),
                require('@/assets/col21.png'),
                require('@/assets/col22.png'),
                require('@/assets/col23.png'),
                require('@/assets/col24.png'),
                require('@/assets/col25.png'),
                require('@/assets/col26.png'),
                require('@/assets/col27.png'),
                require('@/assets/col28.png'),


            ],
            imagesBasket: [
        require('@/assets/crea-basket1.png'),
        require('@/assets/crea-basket2.png'),
        require('@/assets/crea-basket3.png')
        
      ], imagesRoman: [
        require('@/assets/photo-roman.png'),
        require('@/assets/photo-roman1.png'),
        require('@/assets/photo-roman2.png'),
        require('@/assets/photo-roman3.png'),
        require('@/assets/photo-roman4.png'),
        require('@/assets/photo-roman5.png'),
        require('@/assets/photo-roman6.png'),
        require('@/assets/photo-roman7.png'),
        require('@/assets/photo-roman8.png'),
        require('@/assets/photo-roman9.png')
      ],


        };
    },
    mounted() {
        window.addEventListener("resize", this.checkScreenSize);
    },
    beforeUnmount() {
        window.removeEventListener("resize", this.checkScreenSize);
    },
    methods: {
        // Charge correctement les images depuis le dossier assets
        getImage(imageName) {
            return require(`@/assets/${imageName}`);
        },
        openModal(imageName) {
    this.selectedImage = this.getImage(imageName);
    this.isModalOpen = true;
},
        closeModal() {
            this.isModalOpen = false;
            this.selectedImage = '';
        },
        checkScreenSize() {
            this.isMobile = window.innerWidth <= 700;
            this.isOther = window.innerWidth > 700;
        },
        prevSlide(type) {
            if (type === 'Col') {
                this.currentIndexCol = (this.currentIndexCol === 0) ? this.imagesCol.length - 1 : this.currentIndexCol - 1;
            }
            else if (type === 'basket') {
        this.currentIndexBasket = (this.currentIndexBasket === 0) ? this.imagesBasket.length - 1 : this.currentIndexBasket - 1;
      }else if(type === 'roman') {
        this.currentIndexRoman = (this.currentIndexRoman === 0) ? this.imagesRoman.length - 1 : this.currentIndexRoman - 1;
      }else if (type === 'restauratrice') {
        this.currentIndexRestauratrice = (this.currentIndexRestauratrice === 0) ? this.imagesRestauratrice.length - 1 : this.currentIndexRestauratrice - 1;
      }
      else if (type === 'Pokedate') {
        this.currentIndexPokedate = (this.currentIndexPokedate === 0) ? this.imagesPokedate.length - 1 : this.currentIndexPokedate - 1;
      }
        }, 
        nextSlide(type) {
            if (type === 'Col') {
                this.currentIndexCol = (this.currentIndexCol === this.imagesCol.length - 1) ? 0 : this.currentIndexCol + 1;
            } else if (type === 'basket') {
        this.currentIndexBasket = (this.currentIndexBasket === this.imagesBasket.length - 1) ? 0 : this.currentIndexBasket + 1;
      }else if (type === 'roman') {
        this.currentIndexRoman = (this.currentIndexRoman === this.imagesRoman.length - 1) ? 0 : this.currentIndexRoman + 1;
      }else if (type === 'restauratrice') {
        this.currentIndexRestauratrice = (this.currentIndexRestauratrice === this.imagesRestauratrice.length - 1) ? 0 : this.currentIndexRestauratrice + 1;
      }else if (type === 'Pokedate') {
        this.currentIndexPokedate = (this.currentIndexPokedate === this.imagesPokedate.length - 1) ? 0 : this.currentIndexPokedate + 1;
      }
        }  
    },
    
    
};
</script>
